import { colors, white } from '@kmns-internal/furikake/tokens'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import {
  type Device,
  type PlaceNode,
  PlaceNodeTypeEnum,
} from '@ulysses-inc/harami_api_client'
import type React from 'react'

const formatPlaceNodeNames = (placeNodes: PlaceNode[]): string => {
  if (placeNodes.length === 0) {
    return ''
  }
  return placeNodes
    .map(node =>
      node.type === PlaceNodeTypeEnum.PlaceGroup
        ? (node.placeGroup?.name ?? '')
        : (node.place?.name ?? ''),
    )
    .join(' ')
}

interface OwnProps {
  devices: Device[]
  onClickDevice: (device: Device) => void
}

const DeviceList: React.FC<OwnProps> = ({ devices, onClickDevice }) => {
  return (
    <TableContainer
      sx={{
        overflow: 'auto',
        position: 'relative',
        flexGrow: 1,
        bgcolor: white,
      }}
    >
      <Table sx={{ bgcolor: white, width: '100%' }} stickyHeader>
        <TableHead sx={{ backgroundColor: white }}>
          <TableRow>
            <TableCell
              size="small"
              sx={{
                whiteSpace: 'normal',
                backgroundColor: white,
                width: '25%',
              }}
            >
              管理番号
            </TableCell>
            <TableCell
              size="small"
              sx={{
                whiteSpace: 'normal',
                backgroundColor: white,
                width: '30%',
              }}
            >
              キオスク端末名
            </TableCell>
            <TableCell
              size="small"
              sx={{
                whiteSpace: 'normal',
                backgroundColor: white,
                width: '45%',
              }}
            >
              現場名
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {devices.map((device: Device) => (
            <TableRow
              onClick={() => onClickDevice(device)}
              key={device.id}
              sx={{
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: colors.action.hover,
                },
              }}
            >
              <TableCell sx={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                <Typography variant="body2">{device.code}</Typography>
              </TableCell>
              <TableCell sx={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                <Typography variant="body2">{device.name}</Typography>
              </TableCell>
              <TableCell sx={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                <Typography variant="body2">
                  {formatPlaceNodeNames(device.placeNodes)}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default DeviceList
